@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="toolbar">
  <button matButton="text" (click)="backToEntity()">
    <span>
      <mat-icon class="size-16">keyboard_backspace</mat-icon>
      <label class="buttonLabel">{{ 'Back to ' + getDisplayEntityName() }}</label>
    </span>
  </button>
</div>
<app-sureflow-loop-designer [loops]="loopDetails()" [selectedLoopId]="selectedLoopId()" [showCreateScheduleButton]="false" [invalidUnitIds]="invalidUnitIds()"
  (loopSelected)="changeSelectedLoopId($event)" [units]="selectedLoopUnits()" [selectedUnitIds]="selectedUnitIds()"
  (autoSelect)="autoSelectUnits($event)" (addRequested)="addLoop($event)" (selectedUnitsChanged)="unitSelectionChanged($event)"
  (deleteRequested)="deleteLoop($event)" (loopCopied)="copyLoop($event)"
  (deleteLoopUnits)="deleteLoopUnits()" (loopDescriptionChanged)="saveLoopDescription($event)"
  (loopRecalculated)="updateAndRecalculateLoop($event)" (copyUnits)="copyLoopUnits()"
  (addLoopUnit)="addUnitToLoop($event)" (editSelectedUnits)="editUnits()" (exportRequested)="exportLoopData()"
  (addNonSureFlowUnit)="addNonSureFlowUnit($event)" (unitsRearranged)="rearrangeUnits($event)">
</app-sureflow-loop-designer>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
